"use client";
import React, { useRef, useEffect, useState } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import Fancybox from "@/components/FancyboxWrap";
function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

export default function Contact() {
  const [openTab, setOpenTab] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [openTab]);

  return (
    <>
      <Fancybox
        options={{
          Carousel: {
            infinite: false,
          },
        }}
      >
        <div className="w-full min-h-[85vh] h-full  flex flex-col justify-center items-center bg-white  pb-16  p-4 lg:p-10">
          <div className="max-w-7xl w-full h-auto  mt-28  2xl:mt-20 md:border border-[#82603f]">
            <div className="w-full h-full grid grid-cols-1 md:grid-cols-3 gap-3 p-2 md:p-4 items-center">
              <div className=" h-full bg-[#dad8d6] flex items-center justify-center p-5">
                <div className="text-center text-[#7b7c80] grid justify-items-center items-center">
                  <h1 className="font-bold  text-3xl md:text-4xl font-serif text-[#82603f] mb-5">
                    SALES GALLERY
                  </h1>
                  <hr
                    className="w-28 mb-5"
                    style={{ borderTop: "2px solid #82603f " }}
                  />
                  <p className="text-sm max-w-xs w-full font-light mb-5">
                    89 Soi Langsuan , Lumpini, Pathumwan, Bangkok 10330
                  </p>
                  <a
                    href="tel:+6626509899"
                    className="text-sm max-w-md w-full text-[#82603f]"
                  >
                    Tel. 02-650-9899
                  </a>
                </div>
              </div>
              <div className="md:col-span-2 h-full ">
                <div className="w-full relative  h-full">
                  <div className="flex flex-wrap">
                    <div className="w-full">
                      <div className="relative flex flex-col min-w-0 break-words w-full">
                        <div className="md:px-6 md:py-5 flex-auto overflow-hidden">
                          <div className="tab-content tab-space  h-full ">
                            <div
                              className={openTab === 1 ? "block" : "hidden"}
                              id="link1"
                            >
                              <a
                                data-caption=""
                                href="/assets/contact/map1.webp"
                                data-fancybox="map"
                                className="w-full relative "
                              >
                                <Image
                                  src="/assets/contact/map1.webp"
                                  alt="map"
                                  sizes="100vw"
                                  height={0}
                                  width={0}
                                  className="w-full h-full object-contain object-center "
                                />
                              </a>
                            </div>
                            <div
                              className={openTab === 2 ? "block" : "hidden"}
                              id="link2"
                            >
                              <div>
                                <iframe
                                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.672342619365!2d100.54108861532923!3d13.738276601306978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f1850a481df%3A0x43debc0c4c3220c7!2zQmFhbiBTaW5kaG9ybiAo4Lia4LmJ4Liy4LiZ4Liq4Li04LiZ4LiY4LijKQ!5e0!3m2!1sth!2sth!4v1654139834204!5m2!1sth!2sth"
                                  width="100%"
                                  height="450"
                                  style={{ border: 0 }}
                                  allowFullScreen
                                  loading="lazy"
                                  referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-7xl w-full flex justify-center mt-6">
            <div className="w-full flex justify-center mt-2">
              <ul
                className="flex mb-0 list-none  flex-row justify-center gap-1"
                role="tablist"
                aria-owns="tab-1 tab-2"
              >
                <li id="tab-1" role="tab" className="flex-auto text-center">
                  <a
                    className={
                      "text-sm px-5 py-3  block leading-normal w-44 " +
                      (openTab === 1
                        ? "text-white bg-[#82603f] border border-[#82603f]"
                        : "text-gray-500 hover:text-[#82603f] border border-[#82603f]")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(1);
                    }}
                    data-toggle="tab"
                    href="#link1"
                  >
                    Photo Map
                  </a>
                </li>
                <li
                  id="tab-2"
                  role="tab"
                  className="w-fit flex-auto text-center"
                >
                  <a
                    className={
                      "text-sm px-5 py-3  block leading-normal w-44 " +
                      (openTab === 2
                        ? "text-white bg-[#82603f] border border-[#82603f]"
                        : "text-gray-500 hover:text-[#82603f] border border-[#82603f]")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(2);
                    }}
                    data-toggle="tab"
                    href="#link2"
                  >
                    Google Map
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Fancybox>
    </>
  );
}
